import React from "react";
import { useEffect, useState, useRef } from "react";
import useHttp from "../../../hooks/use-http";
import { toast } from "react-toastify";
import SimpleMap from "../../../components/gmaps";
import Modal from "react-modal";

const Settings = () => {


  const attachmentFolder=localStorage.getItem("attachmentFolder");
  const frmRef = useRef({});

  const [backImage, setBackImage] = useState(
    "https://img.freepik.com/premium-vector/anonymous-user-circle-icon-vector-illustration-flat-style-with-long-shadow_520826-1931.jpg?w=1060"
  );
  const [profileUrl, setprofileUrl] = useState();

  const [data, setData] = useState();

  const [latLongclose, setLatLongclose] = useState(false);
  const [latLong, setLatLong] = useState({
    lat:"",
    lng: "",
  });

  const uploadProImage = (e) => {
    const picData = new FormData();
    const file = e.target.files[0];
    picData.append("fileUpload", file, file.name);
    fetch(
      `${
        process.env.REACT_APP_BASE_URL
      }/api/file/${attachmentFolder}/orgnization/${new Date().valueOf()}/${file.name}`,
      {
        method: "POST",
        body: picData,
      }
    )
      .then((res) => res.json())
      .then((data) => {
        setBackImage(`${process.env.REACT_APP_FILE_URL}${data.url}`);
        setprofileUrl(data.url);
      })
      .catch((err) => console.error(err));
  };

  const { sendRequest: getOrg } = useHttp();

  const getData = () => {
    getOrg(
      {
        url: `/api/organisation/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        // //console.log(res);
        setData(res);
      }
    );
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    setprofileUrl(data && data.organizationIcon);
    setBackImage(
      data && `${process.env.REACT_APP_FILE_URL}${data.organizationIcon}`
    );
    frmRef.current.org_name.value = data && data.orgName;
    frmRef.current.org_code.value = data && data.orgCode;
    frmRef.current.org_email.value = data && data.orgEmail;
    frmRef.current.contact_number.value = data && data.phoneNumber;
    frmRef.current.address.value = data && data.address;
    frmRef.current.city.value = data && data.city;
    frmRef.current.state.value = data && data.state;
    frmRef.current.country.value = data && data.country;
    frmRef.current.zipcode.value = data && data.zipCode;
    setLatLong(data && data.latLong);
    frmRef.current.contact_person_name.value = data && data.contactPerson;
    frmRef.current.person_email.value = data && data.contactPersonEmail;
    frmRef.current.contact_person_phone.value =
      data && data.contactPersonPhoneNo;
  }, [data]);

  const { sendRequest: putOrg } = useHttp();

  const handleSubmit = (e) => {
    e.preventDefault();

    const input = {
      orgId: localStorage.getItem("orgId"),
      orgName: frmRef.current.org_name.value,
      orgEmail: frmRef.current.org_email.value,
      organizationIcon: profileUrl,
      address: frmRef.current.address.value,
      phoneNumber: frmRef.current.contact_number.value,
      zipCode: frmRef.current.zipcode.value,
      city: frmRef.current.city.value,
      state: frmRef.current.state.value,
      country: frmRef.current.country.value,
      latLong: latLong,
      contactPerson: frmRef.current.contact_person_name.value,
      contactPersonEmail: frmRef.current.person_email.value,
      contactPersonPhoneNo: frmRef.current.contact_person_phone.value,
    };

    //console.log(input);
    putOrg(
      {
        url: "/api/organisation/",
        method: "PUT",

        body: input,
      },
      (data) => {
        // //console.log(data);
        toast.success("Data Updated Successfully");
      },
      (error) => {
        // console.error("Error:", error);
        toast.error("Error");
      }
    );
  };
  const handleLatLong = (e) => {
    setLatLongclose(true);
  };

  const modalStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    content: {
      backgroundColor: "#fff",
      padding: "20px",
      top: "15%",
      left: "30%",
      borderRadius: "5px",
      maxWidth: "720px",
      maxHeight: "480px",
      height: "500px",
      width: "100%",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    },
  };
  return (
    <>
      {latLongclose && (
        <Modal isOpen={true} style={modalStyles}>
          <SimpleMap
            lat={latLong.lat}
            lng={latLong.lng}
            set={setLatLong}
            close={setLatLongclose}
          />
        </Modal>
      )}
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-6">
            <label className="card-title mx-3 my-3">Organization Details</label>
          </div>
        </div>
        <section className="content">
          <div className="container-fluid">
            <div className="card card-default">
              <form onSubmit={handleSubmit}>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-3 text-center">
                      <div className="form-group mt-5">
                        <img
                          src={`${backImage}`}
                          className="user-image img-circle"
                          width="160"
                          height="160"
                          alt="User Image"
                        />

                        <div className="input-group">
                          <div className="custom-file">
                          <label className="card-title" style={{ cursor: "pointer" }}>
                            <input
                              type="file"
                              className="custom-file-input"
                              id="file"
                              accept="image/*"
                              onChange={uploadProImage}
                            />
                            Upload
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>organization Name</label>
                        <input
                          id="org_name"
                          ref={(el) => (frmRef.current["org_name"] = el)}
                          autoComplete="off"
                          readOnly
                          className="form-control"
                          style={{ width: "100%" }}
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor={"contact_number"}>
                          {"Contact Number"}
                        </label>
                        <input
                          type={"text"}
                          className="form-control"
                          style={{ width: "100%" }}
                          required
                          ref={(el) => (frmRef.current["contact_number"] = el)}
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor={"state"}>{"State"}</label>
                        <input
                          type={"text"}
                          id={"state"}
                          required
                          ref={(el) => (frmRef.current["state"] = el)}
                          className="form-control"
                        />
                      </div>

                      <div className="form-group">
                        <label htmlFor={"person_email"}>
                          {"Contact Person Email"}
                        </label>
                        <input
                          type={"email"}
                          id={"person_email"}
                          required
                          ref={(el) => (frmRef.current["person_email"] = el)}
                          className="form-control"
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor={"location"}>Location</label>&nbsp;
                        <button
                          type={"button"}
                          className="btn-sm btn-success "
                          onClick={handleLatLong}
                        >
                          Add
                        </button>
                      </div>
                    </div>
                    {/* /.col */}
                    <div className="col-md-3">
                      <div className="form-group">
                        <label htmlFor={"org_code"}>
                          {"Organization Code"}
                        </label>
                        <input
                          type={"text"}
                          id={"org_code"}
                          readOnly
                          ref={(el) => (frmRef.current["org_code"] = el)}
                          className="form-control"
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor={"address"}>{"Address"}</label>
                        <input
                          type={"text"}
                          id={"address"}
                          required
                          ref={(el) => (frmRef.current["address"] = el)}
                          className="form-control"
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor={"country"}>{"Country"}</label>
                        <input
                          type={"text"}
                          id={"country"}
                          required
                          ref={(el) => (frmRef.current["country"] = el)}
                          className="form-control"
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor={"contact_person_name"}>
                          {"Contact Person Name"}
                        </label>
                        <input
                          type={"text"}
                          id={"contact_person_name"}
                          required
                          ref={(el) =>
                            (frmRef.current["contact_person_name"] = el)
                          }
                          className="form-control"
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label htmlFor={"email_id"}>
                          {"Organization Email"}
                        </label>
                        <input
                          type="email"
                          id="org_email"
                          className="form-control"
                          ref={(el) => (frmRef.current["org_email"] = el)}
                          autoComplete="off"
                          readOnly
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor={"city"}>{"City"}</label>
                        <input
                          type={"text"}
                          id={"city"}
                          required
                          ref={(el) => (frmRef.current["city"] = el)}
                          className="form-control"
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor={"zipcode"}>{"Zip Code"}</label>
                        <input
                          type={"text"}
                          id={"zipcode"}
                          required
                          ref={(el) => (frmRef.current["zipcode"] = el)}
                          className="form-control"
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor={"contact_person_phone"}>
                          {"Contact Person Phone No"}
                        </label>
                        <input
                          type={"text"}
                          id={"contact_person_name"}
                          required
                          ref={(el) =>
                            (frmRef.current["contact_person_phone"] = el)
                          }
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>
                  <div className=" text-right">
                    <button type="submit" className="btn btn-primary">
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Settings;
